import axios from 'axios'

export const AdminSampleDownloadService = {
  getFile (fileName) {
    return axios({
      method: 'get',
      url: 'adoptions/static/sampledownloads/' + fileName,
      baseURL: '/'
    })
  }
}
